import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { NotificationController } from 'core-components/library/popup'
import { exportPartnersCoverage } from 'partner360/services/report/exportPartnersCoverage'

import { COVERAGE_TRANSLATION_KEYS } from '../../../translations'

interface IExportPartnersCoverageProps {
  fYear?: number
}

export const ExportPartnersCoverage = ({ fYear }: IExportPartnersCoverageProps) => {
  const [isLoading, setIsLoading] = useState(false)

  const { isP360Tester } = useUserRoles()
  const onExportPartnersCoverage = useCallback(async () => {
    if (!fYear) {
      return
    }
    setIsLoading(true)
    const blob = await exportPartnersCoverage(fYear)

    if (!blob) {
      NotificationController.showError({ message: 'Export error' })
      return
    }

    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = `PartnersCoverage-FY${fYear}.pptx`
    link.click()

    URL.revokeObjectURL(url)
    setIsLoading(false)
  }, [fYear])

  if (!isP360Tester) {
    return null
  }

  return (
    <Button onClick={onExportPartnersCoverage} disabled={isLoading}>
      {isLoading ? (
        <Loader dimension={{ height: 20 }} />
      ) : (
        <Translation text={COVERAGE_TRANSLATION_KEYS.exportPartnersCoverage} />
      )}
    </Button>
  )
}
